import { StaticFilterValues } from '../constants/StaticFilterValues';

export const filterEndpoints: Record<string, any> = {
  [StaticFilterValues.PRODUCT_ID]: {
    isAsync: true
  }
};
